export default {"src":"/_next/static/media/footerlogo.3a2139e0.svg","height":44,"width":132};